import { plural } from '@cian/utils';
import { NBSP } from '../../../../../constants/symbols';
import { IRecommendedServicePackage } from '../../../../../redux/reducers';

const DICTIONARY: TDict = {
  top3: ['Топ', 'Топа', 'Топов'],
  premium: ['Премиум', 'Премиума', 'Премиумов'],
  paid: ['Платное', 'Платных', 'Платных'],
};

export const getTitle = (servicePackage: IRecommendedServicePackage) => {
  const { count, serviceId } = servicePackage;

  return `${count}${NBSP}${plural(count, DICTIONARY[serviceId])} со${NBSP}скидкой`;
};
